/** FQuarter value the back end uses for the whole fiscal year row */
export const SMB_FY_QUARTER = 5

/** Fiscal quarters the split can be planned at */
export const SMB_QUARTERS = [1, 2, 3, 4] as const

/** Every FQuarter value accepted by PlanningSMB (1..4 quarters, 5 fiscal year) */
export const SMB_ALL_QUARTERS = [...SMB_QUARTERS, SMB_FY_QUARTER] as const

/** SMB % + EU % always sum to this */
export const SMB_TOTAL_PERCENT = 100

/** Percentages are entered and displayed with one decimal */
export const SMB_PERCENT_FRACTION_DIGITS = 1

export const SMB_PERCENT_STEP = 0.1

/** Metric and currency options come from Planning itself - see PlanningSmbSwitcher props */
export const SMB_CURRENCY_USD = 'USD'
